export default (price: number, discount: number, codeShouldBeApplied: boolean): number => {
    if (codeShouldBeApplied) {
        return applyDiscount(discount, price);
    }
    return price;
};

export const removeDecimals = (value: number): number => {
    return Math.round(value * 100) / 100;
};

const applyDiscount = (discount: number, price: number): number => ((100 - discount) * price) / 100;



// WEBPACK FOOTER //
// ./src/domain/calculatePrice.ts